import ClearableInput from '@rio-cloud/rio-uikit/ClearableInput';
import { useId, useState } from 'react';
import { ConditionallyEnabledButton } from '../ConditionallyEnabledButton';
import Notification from '@rio-cloud/rio-uikit/Notification';
import { UsageMonthSelector } from './UsageMonthSelector';
import { downloadUsageAccountExcelReport } from '../../api/usage/usageExportCalls';

export function UsageExport() {
    const [accountId, setAccountId] = useState<string>('');
    const [year, setYear] = useState<number>(new Date().getFullYear());
    const [month, setMonth] = useState<number>(new Date().getMonth() + 1);
    const [inProgress, setInProgress] = useState<boolean>(false);
    const accountIdInputId = useId();
    const yearMonthInputId = useId();

    return (
        <div className='panel panel-info'>
            <div className='panel-heading'>Usage export</div>
            <div className='panel-body'>
                <div className={'form-group'}>
                    <div className={'display-flex'}>
                        <div className={'flex-1-1 margin-right-10'}>
                            <label htmlFor={accountIdInputId}>{'Account id*'}</label>
                            <ClearableInput
                                id={accountIdInputId}
                                placeholder='Insert account id'
                                value={accountId}
                                onChange={(input: string) => setAccountId(input.trim())}
                            />
                        </div>
                        <div className={'margin-right-10'}>
                            <label htmlFor={yearMonthInputId}>{'Month and year'}</label>
                            <UsageMonthSelector
                                id={yearMonthInputId}
                                selectYearAndMonth={(year, month) => {
                                    setYear(year);
                                    setMonth(month);
                                }}
                                year={year}
                                month={month}
                            />
                        </div>
                    </div>
                </div>
                <ConditionallyEnabledButton
                    disabledText={getDisabledText(!accountId, inProgress)}
                    onClick={async () => {
                        setInProgress(true);
                        try {
                            await downloadUsageAccountExcelReport(accountId, year, month);
                        } catch (e: unknown) {
                            Notification.error(`Could not download usage: ${(e as Error).message}`);
                        } finally {
                            setInProgress(false);
                        }
                    }}
                >
                    Download usage export
                </ConditionallyEnabledButton>
            </div>
        </div>
    );
}

function getDisabledText(missingData: boolean, inProgress: boolean) {
    if (missingData) {
        return 'Please enter account id';
    }
    if (inProgress) {
        return 'In progress ...';
    }
    return undefined;
}
